import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarMobileHelpDialogComponent } from './calendar-mobile-help-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AppMaterialModule } from '../../../../../../../shared/appMaterial/app-material.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [CalendarMobileHelpDialogComponent],
  imports: [CommonModule, MatDialogModule, AppMaterialModule, MatButtonModule],
  entryComponents: [CalendarMobileHelpDialogComponent],
})
export class CalendarMobileHelpDialogModule {}
